import { useState } from 'react'
import styled from 'styled-components'
import { useEventListener, useWindowSize } from 'usehooks-ts'
import vermoegen_dez from '../MainComponent/vermoegen_dezile.json'
import { Chart } from 'components/Chart'
import { ChartAnnotation } from 'components/ChartAnnotation'
import { TextBuilder } from 'components/DynamicText/TextBuilder'
import { TextWidthExtended } from '@ta-interaktiv/react-disco-grid'
import { useMFContext } from 'components/MFHelpers'

export const VermoegensChart = () => {
  const [userPos, setUserPos] = useState<number>(0)
  const percentileId = 1
  const { _t } = useMFContext()
  const { width } = useWindowSize()
  const isMobile = width < 712
  const locales = {
    xAxis: {
      title: [_t('vermoegen_chart_title') + '', ''],
      labels: [_t('lower_5') + '', _t('upper_5') + ''],
    },
    yAxis: {
      title: [
        _t('y_axis_title_wealth') + '',
        _t('y_axis_subline_1_wealth') + '',
      ],
    },
  }

  useEventListener('percentiles' as any, (e) => {
    let dec: number = 0
    vermoegen_dez.forEach((d, i) => {
      if (e.detail.percentiles[percentileId] > d.p) {
        dec = i
      }
    })
    setUserPos(dec)
  })

  var group_val =
    Math.round(
      +vermoegen_dez[Math.max(0, Math.min(19, userPos))].bracket_average / 100
    ) * 100
  const reading = new TextBuilder()
  reading.decide_by_indexgroup(
    userPos,
    [[[20], <>A</>]],
    <>
      <b>{_t('wealth_reading_1', { value: formatNumber(group_val) })}</b>{' '}
      {_t('wealth_reading_2', { value: (20 - userPos - 1) * 5 })}
    </>
  )

  return (
    <TextWidthExtended>
      <VermoegensChartRoot>
        <Chart
          height={isMobile ? 500 : 600}
          userPos={userPos}
          percentileId={percentileId}
          yDomain={[0, 6200000]}
          data={vermoegen_dez.map((m) => m.bracket_average)}
          yAxisWidth={0}
          yTicks={[2000000, 4000000, 6000000]}
          labels={{
            xAxisTitle: locales.xAxis.title,
            xAxisLabels: locales.xAxis.labels,
            yAxisTitle: locales.yAxis.title,
          }}
          Annotation={<ChartAnnotation text={'a'} />}
          reading={reading.get()}
        />
      </VermoegensChartRoot>
    </TextWidthExtended>
  )
}

const VermoegensChartRoot = styled.div``

function formatNumber(num: number) {
  if (num > 499999) {
    return ('' + Math.round(num / 100000) / 10).replace('.', ',') + ' Mio.'
  }
  if (num > 9999) {
    return Math.round(num / 1000) + '’000'
  }

  return num.toString()
}
